export default __webpack_public_path__ + "portal/static/media/Service.a4e3ac1a.svg";